module.exports = __webpack_public_path__ + "static/media/7.352f351b.png";